import React, { Fragment, useState,useEffect } from "react";
import '../../../Css/Maincontent_homePage.scss'

import Notification from './Notification'  
function MainContent(){
    const [navigationBottom, setnavigationBottom] = useState(0)
    const [setScreensize, setseScreensize] = useState(window.innerWidth)
    const [ResponsiveAvailable, setResponsiveAvailable] = useState(false)

    useEffect(() => {
        if(setScreensize<1025) setResponsiveAvailable(true)
        else setResponsiveAvailable (false)
    }, [])

    function navigationBottomHandle(number){
        setnavigationBottom(number)

    }

    return(
        <>
            <section className = "mainContentWrapper">
                <section 
                 style = {
                     ResponsiveAvailable ?
                        navigationBottom==0? {display:"flex"}:{display:"none"}
                        :{display:"flex"} 
                    }
                 className="content notification">
                    <Notification/>
                </section>
                <section
                 style = {
                    ResponsiveAvailable ?
                        navigationBottom==1? {display:"flex"}:{display:"none"}
                        :{display:"flex"} 
                   }
                 className="content posting"
                >
                    asd
                </section>
                <section
                 style = {
                    ResponsiveAvailable ?
                        navigationBottom==2? {display:"flex"}:{display:"none"}
                        :{display:"flex"} 
                   }
                 className="content article"
                >
                    asd
                </section>
            </section>
            <div
             style={ResponsiveAvailable ? {display:"flex"}:{display:"none"}}    
             className="navigationMenu">
                <ul>
                    <li>
                        <a
                        style={navigationBottom==0? {color:"yellow"}:{color:"whitesmoke"}} 
                        onClick= {()=>navigationBottomHandle(0)}>
                            Notification
                        </a>
                    </li>
                    <li>
                        <a
                        style={navigationBottom==1? {color:"yellow"}:{color:"whitesmoke"}} 
                        onClick= {()=>navigationBottomHandle(1)}>
                            Content
                        </a>
                    </li>
                    <li>
                        <a
                        style={navigationBottom==2? {color:"yellow"}:{color:"whitesmoke"}} 
                        onClick= {()=>navigationBottomHandle(2)}>
                            People
                        </a>
                    </li>
                </ul>
            </div>
        </>
        
    )
}

export default MainContent

